import { DispatchWithoutAction, useCallback } from "react";
import createPersistedState from "./createPersistedState";
import { EnvData } from "./types";

export type PolicyAutosave = {
  time: number; // number of ms since epoch UTC
  policy: string;
};

const usePersistedState = createPersistedState<{
  [env: string]: PolicyAutosave;
}>("policy_autosaves");

export function usePolicyAutosave(
  selectedEnv: EnvData
): [PolicyAutosave | null, (policy: string | null) => void] {
  const [autosaves, setAutosaves] = usePersistedState({});
  const currentAutosave = autosaves[selectedEnv.pub_id] || null;
  return [
    currentAutosave,
    (policy) => {
      if (policy !== null && currentAutosave?.policy !== policy) {
        const time = Date.now();
        setAutosaves({ ...autosaves, [selectedEnv.pub_id]: { policy, time } });
      } else {
        const newAutosaves = { ...autosaves };
        delete newAutosaves[selectedEnv.pub_id];
        setAutosaves(newAutosaves);
      }
    },
  ];
}

export function useClearPolicyAutosaves(): DispatchWithoutAction {
  const [_, setAutosaves] = usePersistedState({});
  return useCallback(() => setAutosaves({}), [setAutosaves]);
}
